(function () {
  'use strict';

  function propertiesKey(properties) {
    return JSON.stringify(Object.keys(properties || {}).sort().map(function (key) {
      return [key, String(properties[key])];
    }));
  }

  function sameLine(item, source) {
    return String(item.variant_id || item.id) === String(source.variant_id || source.id) &&
      propertiesKey(item.properties) === propertiesKey(source.properties) &&
      String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || '') ===
      String(source.selling_plan_allocation && source.selling_plan_allocation.selling_plan.id || '');
  }

  function sourceLine(cart, source) {
    var matches = (cart.items || []).filter(function (item) { return sameLine(item, source); });
    if (matches.length > 1) throw new Error('O carrinho mudou. Feche a oferta e confira os produtos.');
    return matches[0];
  }

  function kitLine(cart, token) {
    return (cart.items || []).find(function (item) {
      return item.properties && item.properties._gd_kit_exchange === token;
    });
  }

  // Add first, confirm stock, then remove only the newly added source quantity.
  // A private marker isolates this addition from kits already in the cart.
  async function replace(api, transaction) {
    var cart;
    var source;
    var target = Number(transaction.source.quantity) - transaction.quantity;
    if (!(transaction.quantity > 0) || target < 0 || !transaction.token || !(transaction.variantId > 0)) {
      throw new Error('Troca inválida. O produto avulso foi mantido.');
    }
    try {
      cart = await api.get();
      source = sourceLine(cart, transaction.source);
      var existingKit = kitLine(cart, transaction.token);
      if (existingKit && Number(existingKit.quantity) === transaction.quantity &&
          Number(source && source.quantity || 0) === target) return api.commit(cart);
      if (!source || Number(source.quantity) !== Number(transaction.source.quantity)) {
        throw new Error('O carrinho mudou. Feche a oferta e confira os produtos.');
      }
      if (!existingKit) {
        try {
          await api.post('cart/add.js', { items: [{
            id: transaction.variantId, quantity: transaction.quantity,
            properties: { _gd_kit_exchange: transaction.token }
          }] });
        } catch (addError) {
          // The server may have committed even when the response was lost.
          cart = await api.get();
          if (!kitLine(cart, transaction.token)) throw addError;
        }
      }
      cart = await api.get();
      var confirmedKit = kitLine(cart, transaction.token);
      if (!confirmedKit || Number(confirmedKit.quantity) !== transaction.quantity) {
        throw new Error('Não foi possível confirmar o estoque do kit. O avulso foi mantido.');
      }
      source = sourceLine(cart, transaction.source);
      if (!source || Number(source.quantity) !== Number(transaction.source.quantity)) {
        throw new Error('O carrinho mudou durante a troca. Confira os produtos.');
      }
      try {
        await api.post('cart/change.js', { id: source.key, quantity: target });
      } catch (removeError) {
        cart = await api.get();
        source = sourceLine(cart, transaction.source);
        if (Number(source && source.quantity || 0) !== target) throw removeError;
      }
      cart = await api.get();
      source = sourceLine(cart, transaction.source);
      if (Number(source && source.quantity || 0) !== target ||
          Number((kitLine(cart, transaction.token) || {}).quantity) !== transaction.quantity) {
        throw new Error('Não foi possível confirmar a troca. Confira seu carrinho.');
      }
      return api.commit(cart);
    } catch (error) {
      // Never blindly repeat an uncertain add or remove. Reconcile by marker.
      try {
        cart = await api.get();
        source = sourceLine(cart, transaction.source);
        var addedKit = kitLine(cart, transaction.token);
        var sourceQuantity = Number(source && source.quantity || 0);
        if (addedKit && Number(addedKit.quantity) === transaction.quantity && sourceQuantity === target) {
          return api.commit(cart);
        }
        if (addedKit && sourceQuantity === Number(transaction.source.quantity)) {
          await api.post('cart/change.js', { id: addedKit.key, quantity: 0 });
          cart = await api.get();
          if (kitLine(cart, transaction.token)) throw new Error('A reversão ainda não foi confirmada.');
        } else if (addedKit || sourceQuantity !== Number(transaction.source.quantity)) {
          throw new Error('Carrinho diferente do esperado.');
        }
        api.commit(cart);
      } catch (reconcileError) {
        error.reviewRequired = true;
        error.message = 'Não foi possível confirmar a troca. Confira o carrinho antes de continuar.';
        if (cart) api.commit(cart);
      }
      throw error;
    }
  }

  window.GDKitExchange = { replace: replace, sameLine: sameLine, propertiesKey: propertiesKey };
})();
